function getParam(p) {
    return new URLSearchParams(window.location.search).get(p);
}

function getExpiryRecord(value) {
    const expiryPeriod = 90 * 24 * 60 * 60 * 1000; // 90 days
    const expiryDate = new Date().getTime() + expiryPeriod;
    return {
        value,
        expiryDate
    };
}

function getValidRecord(key) {
    const record = JSON.parse(localStorage.getItem(key));
    return record && record.expiryDate > new Date().getTime() ? record : null;
}

// Collect params
const gclidParam = getParam('gclid');
const utmCampaignParam = getParam('utm_campaign');
const fbclidParam = getParam('fbclid');

// Store params in localStorage
const recordsToStore = {
    gclid: gclidParam ? getExpiryRecord(gclidParam) : null,
    utm_campaign: utmCampaignParam ? getExpiryRecord(utmCampaignParam) : null,
    fbclid: fbclidParam ? getExpiryRecord(fbclidParam) : null,
};
Object.keys(recordsToStore).forEach(key => {
    if (recordsToStore[key]) {
        localStorage.setItem(key, JSON.stringify(recordsToStore[key]));
    }
});

// Prefill form
const form = document.querySelector('[data-paperform-id="2exi7j6y"]');
if (form) {
    let prefillValue = '';
    const gclidLocal = getValidRecord('gclid');
    const utmCampaignLocal = getValidRecord('utm_campaign');
    const fbclidLocal = getValidRecord('fbclid');

    if (gclidLocal) prefillValue += 'gclid=' + gclidLocal.value;
    else if (fbclidLocal) prefillValue += 'fbclid=' + fbclidLocal.value;

    if (utmCampaignLocal) {
        prefillValue += (prefillValue ? '&' : '') + 'utm_campaign=' + utmCampaignLocal.value;
    }
    if (prefillValue) form.setAttribute('prefill', prefillValue);
}